import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { placeholderStyle } from '@/components/Common/Styles/inputStyles';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import COLORS from '@/constants/colors';
import { FORMAT_DATE_1 } from '@/utils/dateTime';
import {
  Box,
  Button,
  FormControlLabel,
  InputAdornment,
  OutlinedInput,
  Stack,
  Switch,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import {
  DigitalClock,
  MobileDatePicker,
  MobileTimePicker,
} from '@mui/x-date-pickers';
import { useDeliveryRegistrationFormViewController } from './DeliveryRegistrationFormViewController';

export const DeliveryRegistrationForm = () => {
  const { uiState, actions } = useDeliveryRegistrationFormViewController();

  return (
    <Stack spacing="12px" mt="20px" width="100%">
      <FormSectionTitle title="Registro de Entrega" />
      <BasicContainer
        content={
          <Grid container columnSpacing="16px" p="16px">
            <Grid xs={12} md={12}>
              <FormItem label="Monto total entregado*">
                <OutlinedInput
                  fullWidth
                  value={uiState.deliveryTotalAmount}
                  placeholder="00.00"
                  sx={{ ...placeholderStyle }}
                  onChange={(e) => actions.onAmountChange(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">$</InputAdornment>
                  }
                />
              </FormItem>
            </Grid>
            <Grid xs={12} md={6}>
              <FormItem label="Fecha confirmada de entrega *">
                <MobileDatePicker
                  sx={{ width: '100%', ...placeholderStyle }}
                  format={FORMAT_DATE_1}
                  closeOnSelect
                  value={uiState.deliveryConfirmedDate}
                  onChange={actions.onDateChange}
                  slotProps={{
                    textField: {
                      inputProps: { readOnly: true },
                      placeholder: 'Fecha confirmada de entrega',
                    },
                  }}
                />
              </FormItem>
            </Grid>
            <Grid xs={12} md={6}>
              <FormItem
                sx={{ mb: '16px' }}
                label="Hora confirmada de entrega (opcional)"
              >
                <MobileTimePicker
                  sx={{ color: COLORS.gray_500 }}
                  value={uiState.deliveryConfirmedTime}
                  onChange={actions.onStartTimeChange}
                  closeOnSelect
                  ampm={false}
                  views={['hours']}
                  format="HH:00"
                  viewRenderers={{
                    hours: (props) => <DigitalClock {...props} skipDisabled />,
                  }}
                  minutesStep={60}
                  slotProps={{
                    textField: {
                      inputProps: { readOnly: true },
                      placeholder: 'Hora confirmada de entrega',
                      sx: { width: '100%', ...placeholderStyle },
                    },
                  }}
                />
              </FormItem>
            </Grid>
            <Grid xs={12} paddingTop={'16px'}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.deliveryOrderCompleted}
                    onChange={(_, checked) =>
                      actions.onOrderCompletedToggle(checked)
                    }
                  />
                }
                label="Pedido completo"
              />
            </Grid>
            <Grid xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.deliveryOrderExtraProducts}
                    onChange={(_, checked) =>
                      actions.onOrderExtraProductsToggle(checked)
                    }
                  />
                }
                label="Productos extra entregados"
              />
            </Grid>
            <Grid xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.deliveryProductPriceAdjusted}
                    onChange={(_, checked) =>
                      actions.onProductPriceAdjustedToggle(checked)
                    }
                  />
                }
                label="Precio de productos ajustado"
              />
            </Grid>
            <Grid xs={12} paddingTop={'32px'}>
              <OutlinedInput
                fullWidth
                sx={{ ...placeholderStyle }}
                placeholder={'Agregar notas para facturación o aclaraciones...'}
                value={uiState.deliveryConfirmedNotes}
                onChange={(e) => actions.onNotesChange(e.target.value)}
              />
            </Grid>
            <Grid xs={12} paddingTop={'8px'}>
              <FormControlLabel
                control={
                  <Switch
                    checked={uiState.appliedMercantoWarranty}
                    onChange={(_, checked) => actions.onWarrantyToggle(checked)}
                  />
                }
                label="Garantía Mercanto Aplicada"
              />
            </Grid>
          </Grid>
        }
        footer={
          <Box
            sx={{
              textAlign: 'right',
              p: '16px',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '16px',
            }}
          >
            <Button
              variant="contained"
              disabled={uiState.cancelDisabled}
              onClick={actions.onCancelChanges}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onSaveChanges}
            >
              Guardar cambios
            </Button>
          </Box>
        }
      />
    </Stack>
  );
};
